module.exports = __webpack_public_path__ + "img/mbway.7d7ca048.svg";